const getDeliveriesValues = (data, hedgeId) =>
  Object.values(data || {})
    .reduce((acc, item) => [...acc, ...item.deliveries], [])
    .filter(item => item.relatedHedge.value === hedgeId);

export { getDeliveriesValues };
